import PotionIndex from "./potion-index";
import './index.css';
import ItemSetIndex from "./item-set-index";
import { useEffect } from "react";
import EggIndex from "./egg-index";

const Compendium: React.FC = () => {
    useEffect(() => {
        if (window.location.hash) {
            const element = document.getElementById(window.location.hash.substring(1));
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, []);

    return (
        <div className='compendium'>
            <ItemSetIndex />
            <PotionIndex />
            <EggIndex />
        </div>
    );
}


export default Compendium;
